export const ratingColors = ["#f1666a", "#bde8ca", "#a4dfb6", "#8bd6a2", "#73ce8e", "#5ac57a"];

export const ratingSelection = { borderColor: "#5ac57a", backgroundColor: "rgba(90, 197, 122, 0.12)" };
